import RcObject from "@/domain/common/RcObject";

export default class RcTableViewFormData extends RcObject {

  get(key) {
    let result = super.get(key);
    if (result != null && result.value) {
      return result["value"];
    }
    return result;
  }
}